import Seo from '@/components/base/Seo';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ContactForm from './components/ContactForm';

const contacts = [
  { icon: 'ri-mail-line', title: '官方邮箱', value: 'hello@waiwaicomic.com', desc: '作品咨询与读者反馈' },
  { icon: 'ri-hand-coin-line', title: '投稿合作', value: 'hi@waiwaicomic.com', desc: '欢迎创作者前来投稿' },
  { icon: 'ri-time-line', title: '更新时间', value: '每日 10:00 / 18:00', desc: '热门连载固定每日更新' },
  { icon: 'ri-chat-3-line', title: '回复时效', value: '3 个工作日内', desc: '工作日会尽快回复你' },
];

export default function Contact() {
  const contactLd = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: '联系我们 - 歪歪漫画',
    inLanguage: 'zh-CN',
    mainEntity: {
      '@type': 'Organization',
      name: '歪歪漫画',
      contactPoint: [{ '@type': 'ContactPoint', email: 'hello@waiwaicomic.com', contactType: 'customer service' }],
    },
  };

  return (
    <>
      <Seo
        title="联系我们 - 歪歪漫画 韩国歪歪漫画恶搞反转爆笑漫画投稿与合作"
        description="歪歪漫画联系我们页面：作品咨询、投稿合作、读者反馈与追更建议。官方邮箱 hello@waiwaicomic.com，工作日 3 天内回复。"
        keywords="歪歪漫画,联系我们,投稿合作,韩国歪歪漫画"
        canonicalPath="/contact"
        jsonLd={[contactLd]}
      />
      <Navbar />
      <main className="min-h-screen bg-background-100 pt-16 md:pt-18">
        <div className="container-page py-8 md:py-10">
          <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '联系我们' }]} />

          <div className="mt-6 max-w-2xl">
            <span className="inline-flex items-center gap-1.5 text-sm font-bold text-primary-600">
              <i className="ri-chat-heart-line" aria-hidden="true" />
              联系我们
            </span>
            <h1 className="mt-2 text-3xl text-foreground-950 md:text-4xl">想聊天、想投稿，随时找我们</h1>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              无论是想聊聊最近的笑点、给作品提建议，还是带着你的原创漫画来投稿，歪歪漫画都很欢迎。
            </p>
          </div>

          <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {contacts.map((c) => (
              <div key={c.title} className="rounded-2xl border border-background-200/70 bg-background-50 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                  <i className={`${c.icon} text-xl`} aria-hidden="true" />
                </span>
                <h2 className="mt-4 text-sm font-bold text-foreground-950">{c.title}</h2>
                <p className="mt-1 text-sm font-bold text-primary-700">{c.value}</p>
                <p className="mt-1 text-xs text-foreground-600">{c.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 grid gap-8 lg:grid-cols-5">
            <div className="lg:col-span-2">
              <div className="rounded-3xl border border-background-200/70 bg-background-50 p-6 md:p-8">
                <h2 className="font-heading text-xl text-foreground-950">其他方式</h2>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                  除了邮箱，你也可以关注我们的社交媒体账号，第一时间获取新作品上架与专题活动信息。
                </p>
                <div className="mt-5 flex flex-col gap-3">
                  {[
                    ['ri-weibo-line', '微博', '@歪歪漫画'],
                    ['ri-qq-line', 'QQ', '歪歪漫画官方群'],
                    ['ri-bilibili-line', '哔哩哔哩', '歪歪漫画动漫号'],
                  ].map(([icon, label, value]) => (
                    <a key={label} href="#" className="flex items-center gap-3 rounded-xl bg-background-100 px-4 py-3 text-sm text-foreground-800 transition-colors hover:bg-accent-100 hover:text-accent-900">
                      <i className={`${icon} text-lg text-primary-600`} aria-hidden="true" />
                      <span className="font-bold">{label}</span>
                      <span className="ml-auto text-foreground-600">{value}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div className="lg:col-span-3">
              <ContactForm />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}